import { BookOpenIcon, DumbbellIcon, type LucideIcon } from 'lucide-react';

export interface Pillar {
  icon: LucideIcon;
  tag: string;
  title: string;
  value: string;
  today: string;
  lead: string;
  items: string[];
}

export const pillars: Pillar[] = [
  {
    icon: BookOpenIcon,
    tag: 'Incluido 📚',
    title: 'Los 6 Tomos del Sistema "Sesión en Mano"',
    value: '59,90€',
    today: 'Hoy: Incluido',
    lead: 'Más de 150 sesiones profesionales para que nunca te falten ejercicios.',
    items: [
      'TOMO 1 — Metodología y Planificación "Cero Estrés": El cerebro de la temporada. Planificación anual, microciclos y el método para preparar sesiones profesionales en 5 minutos.',
      'TOMO 2 — Técnica Individual: Más de 60 ejercicios de control, pase, conducción, regate y finalización con fichas de corrección rápida.',
      'TOMO 3 — Táctica y Juego Colectivo: Salida de balón, presión coordinada, repliegue, transiciones y juego de posición adaptado al fútbol base real.',
      'TOMO 4 — Preparación Física con Balón: Resistencia, velocidad explosiva y prevención de lesiones. Sin vueltas al campo. Con balón siempre.',
      'TOMO 5 — La Pizarra Maestra (Balón Parado): Más de 35 jugadas ensayadas de córner, falta, saque de banda y penaltis con nombres clave para el partido real.',
      'TOMO 6 — Gestión del Vestuario y Padres: El tomo que no enseñan en los cursos. Reunión de padres, jugador suplente, jugador estrella y marca personal del entrenador.'
    ]
  },
  {
    icon: DumbbellIcon,
    tag: 'Incluido 💪',
    title: 'Los 5 Bonos Estratégicos',
    value: '59,50€',
    today: 'Hoy: Incluido',
    lead: 'Los recursos que hacen que el sistema funcione desde el primer día.',
    items: [
      'Bono #1 — Plan de Arranque 7 Días: Por dónde empezar sin agobiarte entre 300 páginas.',
      'Bono #2 — Sesión Express 15 Minutos: Para los días en que el tiempo no alcanza.',
      'Bono #3 — 30 Entrenamientos Listos para Pitar: Sesiones completas con tiempos, ejercicios y correcciones.',
      'Bono #4 — 30 Juegos Técnicos para Fútbol Base: Mejora la técnica individual con competición y motivación.',
      'Bono #5 — Mapa de Temporada en una Página: Toda la temporada planificada en una sola hoja imprimible.'
    ]
  }
];
